module.exports = __webpack_public_path__ + "static/media/Camera icon.9883c434.svg";